// BlogsList.jsx
import React from "react";
import { Link } from "react-router-dom";

const BlogsList = ({ blogs }) => {
  return (
    <section style={styles.container}>
      <h2 style={styles.heading}>Latest Blogs</h2>

      <div style={styles.grid}>
        {blogs.map((blog) => (
          <Link
            key={blog.id}
            to={`/blog/${blog.id}`}
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                ...styles.card,
                backgroundImage: `url(${blog.image})`,
              }}
            >
              <div style={styles.overlay}>
                <h3 style={styles.title}>{blog.title}</h3>
                <p style={styles.desc}>{blog.description}</p>
                <span style={styles.date}>{blog.date}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

const styles = {
  container: {
    paddingBottom: "50px",
    maxWidth: "1100px",
    margin: "0 auto",
  },

  heading: {
    textAlign: "center",
    marginBottom: "40px",
    fontSize: "32px",
    fontWeight: "800",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "25px",
    padding: "20px"
  },

  card: {
    height: "280px",
    borderRadius: "16px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    overflow: "hidden",
    cursor: "pointer",
    transition: "transform 0.4s ease, box-shadow 0.4s ease",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0.2))",
    color: "#fff",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    transition: "0.4s",
  },

  title: {
    fontSize: "20px",
    fontWeight: "700",
    marginBottom: "8px",
  },

  desc: {
    fontSize: "14px",
    marginBottom: "10px",
    color: "#ddd",
  },

  date: {
    fontSize: "12px",
    color: "#aaa",
  },
};

export default BlogsList;
